import { render } from "./TheEducations.vue?vue&type=template&id=53e36e74&ts=true"
import script from "./TheEducations.vue?vue&type=script&lang=ts"
export * from "./TheEducations.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__